// extracted by mini-css-extract-plugin
export default {"header":"header---yGC1s","headerText":"headerText---r5gOF"};